export default "__VITE_ASSET__be0a664d__"